import { Contact } from './contact';

export class Office {
  id: number;
  name: string;

  address: string;
  postcode: string;
  city: string;

  comment: string;
  comments: Array<string>;

  regionId: string;
  regionName: string;
  countryId: string;
  countryName: string;

  isAgent: boolean;
  website: string;
  urls: Array<string>;
  contacts: Array<Contact>;

  // collapse or expand
  showFull: boolean;

  constructor(json: any, accountType = '') {
    this.setContactDetails(json, accountType);
    this.setContacts(json, accountType);
    this.setLocation(json);

    this.showFull = false;
  }

  setContactDetails(json: any, accountType: string) {
    let show = accountType !== '' && accountType !== 'Basic';
    try {
      this.id = json.id || 0;
      this.name = json.name || '';

      this.comment = json.comment || '';
      this.comments = json.comments || [];

      this.isAgent = json.is_agent || false;

      this.urls = json.urls || [];

      let site = this.urls.length > 0 ? this.urls[0] : '';
      this.website = show ? site : 'blurred text';
    } catch (ex) {
      this.id = 0;
      this.name = '';
      this.comment = '';
      this.comments = [];
      this.isAgent = false;
      this.website = show ? '' : 'blurred text';
      this.urls = [];
    }
  }

  setContacts(json: any, accountType: string) {
    try {
      this.contacts = [];
      for (let current = 0; current < json.contacts.length; current++) {
        let contact = new Contact(json.contacts[current], accountType);
        this.contacts.push(contact);
      }

      this.contacts.sort((a, b) => {
        let one = a.desc.toUpperCase();
        let two = b.desc.toUpperCase();
        return (one < two) ? -1 : (one > two) ? 1 : 0;
      });
    } catch (ex) {
      this.contacts = [];
    }
  }

  setLocation(json: any) {
    try {
      this.address = json.address || '';
      this.postcode = json.postcode || '';
      this.city = json.city || '';

      if (json.region !== undefined) {
        this.regionId = json.region.id || '';
        this.regionName = json.region.name || '';
      } else {
        this.regionId = '';
        this.regionName = '';
      }

      if (json.country !== undefined) {
        this.countryId = json.country.id || '';
        this.countryName = json.country.name || '';
      } else {
        this.countryId = '';
        this.countryName = '';
      }
    } catch (ex) {
      this.address = '';
      this.postcode = '';
      this.city = '';

      this.regionId = '';
      this.regionName = '';

      this.countryId = '';
      this.countryName = '';
    }
  }
}



// WEBPACK FOOTER //
// ./node_modules/angular-router-loader/src!./node_modules/angular2-template-loader!./node_modules/@angularclass/hmr-loader!./node_modules/tslint-loader!./src/app/shared/models/office.ts